import update from 'immutability-helper';
import SelfServeBuilderEnum from 'SelfServeBuilder/SelfServeBuilderConstants';
import PopupConstants from 'Popups/PopupConstants';
import SelfServeTooltipTourConstants from './TooltipTourConstants';

const initialState = {
  activeTooltipIndex: SelfServeTooltipTourConstants.TOOLTIP_TOUR_NOT_STARTED_IDX,
  isTourDisplayed: true,
};

const TooltipTourReducer = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }
  const isTooltipTourNotStarted = state.activeTooltipIndex ===
    SelfServeTooltipTourConstants.TOOLTIP_TOUR_NOT_STARTED_IDX;

  switch (action.type) {
    case SelfServeBuilderEnum.SELF_SERVE_BUILDER_CUSTOM_TEMPLATE_DATA_GET_SUCCESS: {
      const isTooltipTourSeen = window.COOKIE.get('preview_tooltip_tour_seen');
      if (isTooltipTourSeen) {
        return update(state, {
          isTourDisplayed: { $set: false },
        });
      }
      return state;
    }
    case SelfServeTooltipTourConstants.PREVIEW_TOOLTIP_HIDE_ALL:
      return update(state, {
        isTourDisplayed: { $set: false },
      });
    case SelfServeTooltipTourConstants.TOOLTIP_NEXT:
      return update(state, {
        activeTooltipIndex: { $set: state.activeTooltipIndex + 1 },
      });
    case SelfServeTooltipTourConstants.PREVIEW_BUTTON_TOOLTIP_SHOW:
      return update(state, {
        activeTooltipIndex: { $set: SelfServeTooltipTourConstants.PREVIEW_BUTTON_TOOLTIP_IDX },
      });
    case PopupConstants.EDIT_POPUP_END:
      if (state.isTourDisplayed && isTooltipTourNotStarted) {
        window.COOKIE.set('preview_tooltip_tour_seen', 1);
        return update(state, {
          activeTooltipIndex: { $set: SelfServeTooltipTourConstants.ANSWER_QUESTION_TOOLTIP_IDX },
        });
      }
      return state;
    default:
      return state;
  }
};

export default TooltipTourReducer;



// WEBPACK FOOTER //
// ./src-react/SelfServeTooltipTour/TooltipTourReducer.jsx